import polyglotI18nProvider from "ra-i18n-polyglot";
import * as ra_language_pt_br from "ra-language-pt-br/src";
import englishMessages from "ra-language-english";
import { TranslationMessages } from "ra-core";
import {
  raAiLanguageEnglish,
} from '@react-admin/ra-ai';
import {
  raAuditLogLanguageEnglish,
} from '@react-admin/ra-audit-log';
import {
  raFormLayoutLanguageEnglish,
} from '@react-admin/ra-form-layout';
import {
  raRealTimeLanguageEnglish,
} from '@react-admin/ra-realtime';
import {
  raRelationshipsLanguageEnglish,
} from '@react-admin/ra-relationships';
import {
  raSearchLanguageEnglish,
} from '@react-admin/ra-search';
import {
  raTreeLanguageEnglish,
} from '@react-admin/ra-tree';

import type { SupportedLocales } from "./types";
import { ptBrMessages } from "./pt-br";
import { enMessages } from "./en";

const messages = {
  "pt-br": {
    ...ra_language_pt_br.default,
    ...ptBrMessages,
  } as unknown as TranslationMessages,
  en: {
    ...englishMessages,
    raAiLanguageEnglish,
    raRealTimeLanguageEnglish,
    raRelationshipsLanguageEnglish,
    raTreeLanguageEnglish,
    raSearchLanguageEnglish,
    raAuditLogLanguageEnglish,
    raFormLayoutLanguageEnglish,
    ...enMessages,
    // Override ra-form-layout translations if needed
    "ra-form-layout": {
      ...raFormLayoutLanguageEnglish,
      ...enMessages["ra-form-layout"],
    },
  } as unknown as TranslationMessages,
};

export const i18nProvider = polyglotI18nProvider(
  (locale: string): TranslationMessages => messages[locale as SupportedLocales],
  "pt-br",
  [
    { locale: "pt-br", name: "Português" },
    // { locale: 'en', name: 'English' }
  ],
);
